import { Component, OnInit, Input } from '@angular/core';
import { MultimediaManagerDialogLayoutService } from '../multimedia-manager-dialog-layout/multimedia-manager-dialog-layout.service';
import { MultimediaManagerDialogService } from '../multimedia-manager-dialog/multimedia-manager-dialog.service';

@Component({
  selector: 'app-multimedia-manager-dialog-item-folder',
  templateUrl: './multimedia-manager-dialog-item-folder.component.html',
  styleUrls: ['./multimedia-manager-dialog-item-folder.component.scss']
})
export class MultimediaManagerDialogItemFolderComponent implements OnInit {

  @Input() folder;
  @Input() currentFolder;
  @Input() currentFatherFolder;

  constructor(private multimediaManagerDialogLayoutService: MultimediaManagerDialogLayoutService,
              private multimediaManagerDialogService: MultimediaManagerDialogService) { }

  ngOnInit() {
  }

  public showDetails(e) {
    this.multimediaManagerDialogLayoutService.showDetails(this.folder);
    e.stopPropagation();
  }

  public openFolder() {
    this.multimediaManagerDialogService.folderChanged(this.folder);
  }
}
